module.exports = __webpack_public_path__ + "media/images/index/feature/top-aoj-e-a63e5fe8ffd615c97613f0570e944ce7.png";